import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${API}/api`, withCredentials: true });

export const formatBRL = (cents) =>
    (Number(cents) || 0) > 0
        ? (Number(cents) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        : "";

export const fileUrl = (storagePath) => `${API}/api/files/${storagePath}`;

export const getAdminToken = () => sessionStorage.getItem("zf_admin_token");
export const setAdminToken = (t) =>
    t ? sessionStorage.setItem("zf_admin_token", t) : sessionStorage.removeItem("zf_admin_token");

export const authHeaders = () => {
    const t = getAdminToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Algo deu errado. Tente novamente.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
